import React, { useEffect } from "react";
import Hero from "components/hero/Hero";
import Footer from "components/footers/FiveColumnDark";
import RecruitmentCardTwoCol from "components/cards/RecruitmentCardTwoColNew";
import SplashAnimationContainer from "helpers/SplashAnimationContainer";
import GlobalStyle from "helpers/GlobalStyle";
import useScreenSize from "helpers/useScreenSize";
import ImageCarousel from "components/Recruitment/RecruitmentProcessDetails";
import RecruitmentQA from "components/Recruitment/RecruitmentQA";
export default () => {
  const { isXs } = useScreenSize();

  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash;
      if (!hash) return;
      const section = document.getElementById(hash.substring(1));
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    };

    scrollToHash();
    window.addEventListener("hashchange", scrollToHash);
    return () => window.removeEventListener("hashchange", scrollToHash);
  }, []);

  return (
    <div style={{ marginTop: "50px" }}>
      <GlobalStyle />
      <Hero isXs={isXs} />
      <SplashAnimationContainer>
        <div id="job-postings" style={{ scrollMarginTop: 90 }}>
          <RecruitmentCardTwoCol isXs={isXs} />
        </div>
        <div id="job-hunting-faq" style={{ scrollMarginTop: 90 }}>
          <RecruitmentQA />
        </div>
        <div id="training-programs" style={{ scrollMarginTop: 90 }}>
          <ImageCarousel isXs={isXs} />
        </div>
        <Footer isXs={isXs} />
      </SplashAnimationContainer>
    </div>
  );
};
